import { AnalyticsService } from "./analytics.service";
import * as $ from 'jquery';
var ValidationService = /** @class */ (function () {
    function ValidationService() {
        this.errors = [];
        this.dlFieldsError = [];
    }
    ValidationService.getInstance = function () {
        if (!ValidationService.instance) {
            ValidationService.instance = new ValidationService();
        }
        return ValidationService.instance;
    };
    //
    //
    // FORMS !!!! PLEASE DON'T REMOVE THIS AS THERE ARE A LOT OF FORMS THAT ARE USING THIS FUNCTION ON DEV
    //
    //
    ValidationService.prototype.validateEnterprise = function (fields) {
        var analyticsService = new AnalyticsService();
        var dlFieldsError = [];
        var valid = true;
        var errors = [];
        for (var i = 0; i < fields.length; i++) {
            var field = fields[i];
            var formGroup = $(field).closest('.form__group');
            if (formGroup) {
                $(field).closest('.form__group').removeClass('form__group--error');
            }
            if (!formGroup.hasClass("form__group--hidden")) {
                if (field.classList.contains('form__input--required')) {
                    var type = field.type;
                    if (type == 'checkbox') {
                        var checked = field.checked;
                        if (!checked) {
                            dlFieldsError.push(field.name);
                            var form_group = $(field).closest('.form__group');
                            var label = form_group.find('label').text();
                            form_group.addClass('form__group--error');
                            errors.push(label + ' is required');
                            valid = false;
                        }
                    }
                    else {
                        if (!field.value) {
                            //Analytics - Add the fiel into the log
                            dlFieldsError.push(field.name);
                            var form_group = $(field).closest('.form__group');
                            var label = form_group.find('label').text();
                            form_group.addClass('form__group--error');
                            errors.push(label + ' is required');
                            valid = false;
                        }
                        else if (field.value.charAt(0) == " ") {
                            //Analytics - Add the fiel into the log
                            dlFieldsError.push(field.name);
                            var form_group = $(field).closest('.form__group');
                            var label = form_group.find('label').text();
                            form_group.addClass('form__group--error');
                            errors.push(label + ' is required');
                            valid = false;
                        }
                    }
                }
                //Validate Text Area Field
                if (field.classList.contains('form__textarea--required')) {
                    if (!field.value) {
                        //Analytics - Add the fiel into the log
                        dlFieldsError.push(field.name);
                        var form_group = $(field).closest('.form__group');
                        var label = form_group.find('label').text();
                        form_group.addClass('form__group--error');
                        errors.push(label + ' is required');
                        valid = false;
                    }
                }
                if (field.classList.contains('form__input--contact') && (field.value.length > 0)) {
                    if (field.value) {
                        if (!this.validateContact(field)) {
                            var form_group = $(field).closest('.form__group');
                            var label = form_group.find('label').text();
                            form_group.addClass('form__group--error');
                            errors.push(label + ' is invalid');
                            valid = false;
                            // Analytics - ensure that the field name is not already in the log
                            if (field.name && dlFieldsError.indexOf(field.name) < 0) {
                                dlFieldsError.push(field.name);
                            }
                        }
                    }
                }
                if (field.classList.contains('form__input--contact-international')) {
                    if (field.value.length > 0) {
                        this.validateContactInternationalNumber(field);
                    }
                }
                if (field.classList.contains('form__input--areaCode') && (field.value.length > 0)) {
                    if (field.value) {
                        if (!this.validateAreaCode(field)) {
                            var form_group = $(field).closest('.form__group');
                            var label = form_group.find('label').text();
                            form_group.addClass('form__group--error');
                            errors.push(label + ' is invalid');
                            valid = false;
                            // Analytics - ensure that the field name is not already in the log
                            if (field.name && dlFieldsError.indexOf(field.name) < 0) {
                                dlFieldsError.push(field.name);
                            }
                        }
                    }
                }
                if (field.classList.contains('form__input--identification')) {
                    if (field.value) {
                        var form_group = $(field).closest('.form__group');
                        if (!this.validateSAIDLessStrict(field) && !form_group.hasClass("form__group--hidden")) {
                            var label = form_group.find('label').text();
                            form_group.addClass('form__group--error');
                            errors.push('South African ID number is invalid');
                            valid = false;
                            // Analytics - ensure that the field name is not already in the log
                            if (field.name && dlFieldsError.indexOf(field.name) < 0) {
                                dlFieldsError.push(field.name);
                            }
                        }
                    }
                }
                if (field.classList.contains('form__input--email')) {
                    if (field.value) {
                        if (!this.validateEmail(field)) {
                            var form_group = $(field).closest('.form__group');
                            var label = form_group.find('label').text();
                            form_group.addClass('form__group--error');
                            errors.push(label + ' is invalid');
                            valid = false;
                            // Analytics - ensure that the field name is not already in the log
                            if (field.name && dlFieldsError.indexOf(field.name) < 0) {
                                dlFieldsError.push(field.name);
                            }
                        }
                    }
                }
                if (field.classList.contains('form__input--website-address')) {
                    if (field.value) {
                        if (!this.validateWebsiteAddress(field)) {
                            var form_group = $(field).closest('.form__group');
                            var label = form_group.find('label').text();
                            form_group.addClass('form__group--error');
                            errors.push(label + ' is invalid');
                            valid = false;
                            // Analytics - ensure that the field name is not already in the log
                            if (field.name && dlFieldsError.indexOf(field.name) < 0) {
                                dlFieldsError.push(field.name);
                            }
                        }
                    }
                }
                if (field.classList.contains('form__input--currency')) {
                    if (field.value) {
                        if (!this.validateCurrency(field)) {
                            var form_group = $(field).closest('.form__group');
                            var label = form_group.find('label').text();
                            form_group.addClass('form__group--error');
                            errors.push(label + ' is invalid');
                            valid = false;
                            // Analytics - ensure that the field name is not already in the log
                            if (field.name && dlFieldsError.indexOf(field.name) < 0) {
                                dlFieldsError.push(field.name);
                            }
                        }
                    }
                }
                if (field.classList.contains('form__input--currency2')) {
                    if (field.value) {
                        if (!this.validateCurrency2(field)) {
                            var form_group = $(field).closest('.form__group');
                            var label = form_group.find('label').text();
                            form_group.addClass('form__group--error');
                            errors.push(label + ' is invalid');
                            valid = false;
                            // Analytics - ensure that the field name is not already in the log
                            if (field.name && dlFieldsError.indexOf(field.name) < 0) {
                                dlFieldsError.push(field.name);
                            }
                        }
                    }
                }
                if (field.classList.contains('form__input--account')) {
                    if (field.value) {
                        if (!this.validateAccount(field)) {
                            var form_group = $(field).closest('.form__group');
                            var label = form_group.find('label').text();
                            form_group.addClass('form__group--error');
                            errors.push(label + ' is invalid');
                            valid = false;
                            // Analytics - ensure that the field name is not already in the log
                            if (field.name && dlFieldsError.indexOf(field.name) < 0) {
                                dlFieldsError.push(field.name);
                            }
                        }
                    }
                }
                if (field.classList.contains('form__input--minmaxLength')) {
                    if (field.value) {
                        if (!this.validateMinMaxLength(field)) {
                            var form_group = $(field).closest('.form__group');
                            var label = form_group.find('label').text();
                            form_group.addClass('form__group--error');
                            errors.push(label + ' is invalid');
                            valid = false;
                            // Analytics - ensure that the field name is not already in the log
                            if (field.name && dlFieldsError.indexOf(field.name) < 0) {
                                dlFieldsError.push(field.name);
                            }
                        }
                    }
                }
                if (field.classList.contains('form__input--busReg')) {
                    if (field.value) {
                        var _check = field.value.split('/');
                        var _regValid = true;
                        if (_check.length > 1) {
                            var _valid1 = true;
                            var _valid2 = true;
                            var _valid3 = true;
                            if (_check.length == 3) {
                                var _seg1 = new RegExp('^/d{4}$');
                                var _seg2 = new RegExp('^/d{6}$');
                                var _seg3 = new RegExp('^/d{2}$');
                                if (_seg1.test(_check[0])) {
                                    _valid1 = false;
                                }
                                if (_seg2.test(_check[1])) {
                                    _valid2 = false;
                                }
                                if (_seg3.test(_check[2])) {
                                    _valid3 = false;
                                }
                                if (!_valid1 || !_valid2 || !_valid3) {
                                    valid = false;
                                }
                            }
                            else {
                                _regValid = false;
                            }
                        }
                        else if (field.value.length >= 12) {
                            var _numberCheck = new RegExp('^[0-9]+$');
                            if (!_numberCheck.test(field.value)) {
                                _regValid = false;
                            }
                        }
                        if (!_regValid) {
                            valid = false;
                            var form_group = $(field).closest('.form__group');
                            var label = form_group.find('label').text();
                            form_group.addClass('form__group--error');
                            errors.push(label + ' is invalid');
                        }
                    }
                }
                if ((field.type == 'input') || (field.type == 'textarea')) {
                    var format;
                    if (field.classList.contains('form__input--email')) {
                        format = /[`~!#$%^&*()=\[\]{};:"\\|,<>\/?]/;
                    }
                    else if (field.classList.contains('form__input--website-address')) {
                        format = /[`~!@#$%^&*()+=\[\]{};"\\|,<>?]/;
                    }
                    else if (field.type == "textarea") {
                        format = /[`~!@#$%^&*()_+=\[\]{};:"\\|<>\/?]/;
                    }
                    else {
                        format = /[`~!@#$%^&*()_+=\[\]{};:"\\|,<>\/?]/;
                    }
                    if (format.test(field.value) && !field.classList.contains('form__input--busReg')) {
                        var form_group = $(field).closest('.form__group');
                        var label = form_group.find('label').text();
                        form_group.addClass('form__group--error');
                        errors.push(label + ' is invalid');
                        valid = false;
                        // Analytics - ensure that the field name is not already in the log
                        if (field.name && dlFieldsError.indexOf(field.name) < 0) {
                            dlFieldsError.push(field.name);
                        }
                    }
                }
            }
        }
        //If we have any errors on client side, trigger analytics to record all fields
        if (dlFieldsError.length) {
            analyticsService.dtmFormFieldsValidationFail(dlFieldsError.join(','));
        }
        return {
            valid: valid,
            errors: errors
        };
    };
    //
    //
    // FORMS
    //
    //
    ValidationService.prototype.validate = function (fields) {
        var analyticsService = new AnalyticsService();
        this.dlFieldsError = [];
        for (var i = 0; i < fields.length; i++) {
            var field = fields[i];
            if (field.type != 'hidden') {
                this.validateBlur(field);
                this.errors = [];
            }
        }
        //If we have any errors on client side, trigger analytics to record all fields
        if (this.dlFieldsError.length) {
            analyticsService.dtmFormFieldsValidationFail(this.dlFieldsError.join(','));
        }
    };
    ValidationService.prototype.validateBlur = function (field) {
        var formGroup = field.closest('.form__group');
        this.errors = [];
        if (formGroup) {
            field.closest('.form__group').classList.remove('form__group--error');
            //const errorMessage = field.querySelector(".form__group--error_message");
            // FIX: Query for error message on formGroup, not field
            var errorMessage = formGroup.querySelector(".form__group--error_message");
            if (errorMessage) {
                errorMessage.remove();
            }
        }
        if (!formGroup.classList.contains("form__group--hidden")) {
            if ((field.classList.contains('form__input--required')) || (field.classList.contains('form__textarea--required'))) {
                this.validateRequired(field);
            }
            if (field.classList.contains('form__input--initials')) {
                if (field.value.length > 0) {
                    this.validateInitials(field);
                }
            }
            if (field.classList.contains('form__input--contact')) {
                if (field.value.length > 0) {
                    this.validateContactNumber(field);
                }
            }
            if (field.classList.contains('form__input--contact-international')) {
                if (field.value.length > 0) {
                    this.validateContactInternationalNumber(field);
                }
            }
            if (field.classList.contains('form__input--areaCode')) {
                if (field.value.length > 0) {
                    this.validateAreaCode(field);
                }
            }
            if (field.classList.contains('form__input--identification')) {
                if (field.value.length > 0) {
                    this.validateSAIDLessStrict(field);
                }
            }
            if (field.classList.contains('form__input--email')) {
                if (field.value.length > 0) {
                    this.validateEmail(field);
                }
            }
            if (field.classList.contains('form__input--website-address')) {
                if (field.value.length > 0) {
                    this.validateWebsiteAddress(field);
                }
            }
            if (field.classList.contains('form__input--currency')) {
                if (field.value.length > 0) {
                    this.validateCurrency(field);
                }
            }
            if (field.classList.contains('form__input--currency2')) {
                if (field.value.length > 0) {
                    this.validateCurrency2(field);
                }
            }
            if (field.classList.contains('form__input--busReg')) {
                if (field.value.length > 0) {
                    this.validateBusinessRegistrationNumber(field);
                }
            }
            if (field.classList.contains('form__input--account')) {
                if (field.value.length > 0) {
                    this.validateAccountNumber(field);
                }
            }
            if (field.classList.contains('marketing-consent-radio')) {
                var form = field.closest('form');
                if (!this.getDataConsentValue(form, field.name)) {
                    this.dlFieldsError.push(field.name);
                    this.errors.push('This field is required');
                    $(field).closest('.form__group').addClass('form__group--error');
                }
                else {
                    $(field).closest('.form__group').removeClass('form__group--error');
                }
            }
            if ((field.localName === 'input') || (field.type === 'textarea')) {
                var format = void 0;
                if (field.classList.contains('form__input--email')) {
                    format = /[`~!#$%^&*()=\[\]{};:"\\|,<>\/?]/;
                }
                else if (field.classList.contains('js-date-picker') || field.classList.contains('js-date-picker-full') || field.classList.contains('js-date-picker-today-disabled') || field.classList.contains('js-date-picker-full-today-disabled') || field.classList.contains('js-date-picker-enable-previous-days')) {
                    format = /[`~!#$%^&*()_+=\[\]{};:"\\|,<>?]/;
                }
                else if (field.classList.contains('form__input--website-address')) {
                    format = /[`~!@#$%^&*()+=\[\]{};"\\|,<>?]/;
                }
                else if (field.type === 'textarea') {
                    format = /[`~!@#$%^&*()_+=\[\]{};:"\\|<>\/?]/;
                }
                else {
                    format = /[`~!@#$%^&*()_+=\[\]{};:"\\|,<>\/?]/;
                }
                if (format.test(field.value) && !field.classList.contains('form__input--busReg') && !field.classList.contains('form__input--fileUpload')) {
                    // analytics - Add the field into the log
                    this.dlFieldsError.push(field.name);
                    var form_group = $(field).closest('.form__group');
                    form_group.addClass('form__group--error');
                    this.errors.push('Please remove special characters');
                }
            }
            this.addErrorMessage(field, this.errors);
        }
    };
    ValidationService.prototype.addErrorMessage = function (pElement, pMessages) {
        var _parent = pElement.closest('.form__group');
        if (_parent) {
            var _errorDiv = _parent.querySelector(".form__group--error_message");
            if (_errorDiv) {
                _errorDiv.remove();
            }
            if (pMessages.length > 0) {
                _errorDiv = document.createElement("div");
                _errorDiv.classList.add("form__group--error_message");
                var _errors_1 = document.createElement("ul");
                pMessages.forEach(function (pMessage) {
                    var _error = document.createElement("li");
                    _error.innerHTML = pMessage;
                    _errors_1.appendChild(_error);
                });
                _errorDiv.appendChild(_errors_1);
                if (_parent) {
                    _parent.appendChild(_errorDiv);
                }
            }
        }
    };
    ValidationService.prototype.addError = function (pElement, pMessages) {
        var _parent = pElement.closest('.form__group');
        if (_parent) {
            var _errorDiv = _parent.querySelector(".form__group--error_message");
            if (_errorDiv) {
                _errorDiv.remove();
            }
            if (pMessages.length > 0) {
                _parent.classList.add('form__group--error');
                _errorDiv = document.createElement("div");
                _errorDiv.classList.add("form__group--error_message");
                var _errors_2 = document.createElement("ul");
                pMessages.forEach(function (pMessage) {
                    var _error = document.createElement("li");
                    _error.innerHTML = pMessage;
                    _errors_2.appendChild(_error);
                });
                _errorDiv.appendChild(_errors_2);
                if (_parent) {
                    _parent.appendChild(_errorDiv);
                }
            }
            else {
                _parent.classList.remove('form__group--error');
            }
        }
    };
    // 
    // 
    // FORMATTERS
    // 
    //
    ValidationService.prototype.validateRequired = function (field) {
        var type = field.type;
        var valid = true;
        if (type == 'checkbox') {
            var checked = field.checked;
            if (!checked) {
                this.dlFieldsError.push(field.name);
                var form_group = $(field).closest('.form__group');
                form_group.addClass('form__group--error');
                this.errors.push('This checkbox is required to continue');
                valid = false;
            }
        }
        else if (type == 'number') {
            if (isNaN(field.value)) {
                this.dlFieldsError.push(field.name);
                var form_group = $(field).closest('.form__group');
                form_group.addClass('form__group--error');
                this.errors.push('This field can only accept numbers');
                valid = false;
            }
            else if (field.value.length == 0) {
                this.dlFieldsError.push(field.name);
                var form_group = $(field).closest('.form__group');
                form_group.addClass('form__group--error');
                this.errors.push('This field is required');
                valid = false;
            }
            else if (field.value.charAt(0) == 0 && (!field.classList.contains("form__input--identification") && !field.classList.contains('form__input--contact') && !field.classList.contains('form__input--areaCode'))) {
                this.dlFieldsError.push(field.name);
                var form_group = $(field).closest('.form__group');
                form_group.addClass('form__group--error');
                this.errors.push('This field can not start with 0');
                valid = false;
            }
        }
        else if (type == "select" || type == "select-one" || type == "select-multiple") {
            if (field.value == "") {
                this.dlFieldsError.push(field.name);
                var form_group = $(field).closest('.form__group');
                form_group.addClass('form__group--error');
                this.errors.push('This field is required');
                valid = false;
            }
        }
        else if (type == "textarea") {
            if (!field.value) {
                //Analytics - Add the field into the log
                this.dlFieldsError.push(field.name);
                var form_group = $(field).closest('.form__group');
                form_group.addClass('form__group--error');
                this.errors.push('This field is required');
                valid = false;
            }
        }
        else if (field.classList.contains("form__input--identification")) {
            if (!field.value) {
                //Analytics - Add the field into the log
                this.dlFieldsError.push(field.name);
                var form_group = $(field).closest('.form__group');
                form_group.addClass('form__group--error');
                this.errors.push('This field is required');
                valid = false;
            }
        }
        else if (field.classList.contains("form__input--identification--passport")) {
            if (!field.value) {
                //Analytics - Add the field into the log
                this.dlFieldsError.push(field.name);
                var form_group = field.closest('.form__group');
                form_group.classList.add('form__group--error');
                this.errors.push('This field is required');
                valid = false;
            }
        }
        else if (field.classList.contains("form__input--initials")) {
            if (!field.value) {
                //Analytics - Add the fiel into the log
                this.dlFieldsError.push(field.name);
                var form_group = $(field).closest('.form__group');
                form_group.addClass('form__group--error');
                this.errors.push('This field is required');
                valid = false;
            }
        }
        else if (field.classList.contains("form__input--account")) {
            if (!field.value) {
                //Analytics - Add the fiel into the log
                this.dlFieldsError.push(field.name);
                var form_group = $(field).closest('.form__group');
                form_group.addClass('form__group--error');
                this.errors.push('This field is required');
                valid = false;
            }
        }
        else if (field.classList.contains("form__input--busReg")) {
            if (!field.value) {
                //Analytics - Add the fiel into the log
                this.dlFieldsError.push(field.name);
                var form_group = $(field).closest('.form__group');
                form_group.addClass('form__group--error');
                this.errors.push('This field is required');
                valid = false;
            }
        }
        else if (field.classList.contains("form__input--contact")) {
            if (!field.value) {
                //Analytics - Add the fiel into the log
                this.dlFieldsError.push(field.name);
                var form_group = $(field).closest('.form__group');
                form_group.addClass('form__group--error');
                this.errors.push('This field is required');
                valid = false;
            }
        }
        else {
            if (!field.value) {
                //Analytics - Add the field into the log
                this.dlFieldsError.push(field.name);
                var form_group = $(field).closest('.form__group');
                form_group.addClass('form__group--error');
                this.errors.push('This field is required');
                valid = false;
            }
            else if (field.value.charAt(0) == ' ') {
                //Analytics - Add the field into the log
                this.dlFieldsError.push(field.name);
                var form_group = $(field).closest('.form__group');
                form_group.addClass('form__group--error');
                this.errors.push('This field cannot start with spaces');
                valid = false;
            }
            else if (field.value.length < 2) {
                this.dlFieldsError.push(field.name);
                var form_group = $(field).closest('.form__group');
                form_group.addClass('form__group--error');
                this.errors.push('This field requires a minimum of 2 characters');
                valid = false;
            }
        }
        return valid;
    };
    // } else if (field.classList.contains("form__input--contact")) {
    // 	// Check required for contact inputs
    // 	if (!field.value) {
    // 		//Analytics - Add the field into the log
    // 		this.dlFieldsError.push(field.name);
    // 		let form_group = $(field).closest('.form__group');
    // 		form_group.addClass('form__group--error');
    // 		this.errors.push('This field is required');
    // 		valid = false;
    // 	}
    // 	} else if (!field.value) {
    // 	//Analytics - Add the field into the log
    // 		this.dlFieldsError.push(field.name);
    // 		let form_group = $(field).closest('.form__group');
    // 		form_group.addClass('form__group--error');
    // 		this.errors.push('This field is required');
    // 		valid = false;
    // } else if (field.value.length > 40) {
    // 	//Analytics - Add the field into the log for exceeding max length
    // 		this.dlFieldsError.push(field.name);
    // 		let form_group = $(field).closest('.form__group');
    // 		form_group.addClass('form__group--error');
    // 		this.errors.push('This field must be 40 characters or less');
    // 		valid = false;
    // 	} else if (field.classList.contains('form__input--email')) {
    // 		// Email field: validate format
    // 		const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    // 		if (!emailPattern.test(field.value)) {
    // 			this.dlFieldsError.push(field.name);
    // 			let form_group = $(field).closest('.form__group');
    // 			form_group.addClass('form__group--error');
    // 			this.errors.push('Please enter a valid email address');
    // 			valid = false;
    // 		}
    // 	} else if (
    // 		/[ '\-]/.test(field.value.charAt(0)) || // First char is space, hyphen, or apostrophe
    // 		/[ '\-]/.test(field.value.charAt(1)) || // Second char is space, hyphen, or apostrophe
    // 			/^[0-9]+$/.test(field.value) ||         // Entire input is numbers
    // 		/[^a-zA-Z\s'\-]/.test(field.value)      // Any disallowed special characters
    // 	) {
    // 		// Name/surname validation
    // 		this.dlFieldsError.push(field.name);
    // 		let form_group = $(field).closest('.form__group');
    // 		form_group.addClass('form__group--error');
    // 		if (
    // 			field.name.toLowerCase().includes('surname') || 
    // 			$(field).closest('.form__group').find('label').text().toLowerCase().includes('surname')
    // 		) {
    // 			this.errors.push('Please enter a valid surname');
    // 		} else {
    // 			this.errors.push('Please enter a valid name');
    // 		}
    // 		valid = false;
    // 	} else if (field.value.length < 2) {
    // 		this.dlFieldsError.push(field.name);
    // 		let form_group = $(field).closest('.form__group');
    // 		form_group.addClass('form__group--error');
    // 		this.errors.push('This field requires a minimum of 2 characters');
    // 		valid = false;
    // 	}
    // 	return valid;
    // }
    ValidationService.prototype.validateInitials = function (field) {
        var valid = true;
        if (field.value.length < 1) {
            this.errors.push('This field requires a minimum of 1 character');
            valid = false;
        }
        return valid;
    };
    ValidationService.prototype.validateContactNumber = function (field) {
        // check if international
        var international = false;
        var domain = window.location.href;
        if (domain.includes('https://preview.standardbank.co.za/southafrica') ||
            domain.includes('http://pwempas1v.standardbank.co.za:8080/southafrica') ||
            domain.includes('http://pwempas2v.standardbank.co.za:8080/southafrica') ||
            domain.includes('http://uwempas1v.standardbank.co.za:8080/southafrica') ||
            domain.includes('http://uwempas2v.standardbank.co.za:8080/southafrica') ||
            domain.includes('http://dsbgchop183.standardbank.co.za:8080/southafrica') ||
            domain.includes('https://www.standardbank.co.za') ||
            domain.includes('https://wem.standardbank.co.za/southafrica') ||
            domain.includes('https://uatprev.standardbank.co.za/southafrica') ||
            domain.includes('http://10.109.131.53:8080/southafrica') ||
            domain.includes('http://10.108.88.62:8080/southafrica') ||
            domain.includes('https://www.looksee.co.za') ||
            domain.includes('http://10.109.131.53:8080/looksee') ||
            domain.includes('http://10.108.88.62:8080/looksee') ||
            domain.includes('https://uatprev.standardbank.co.za/looksee')) {
            international = false;
        }
        else {
            international = true;
        }
        if (international) {
            return true;
        }
        // --- Live sanitization: remove non-digits and limit to 10 ---
        var rawValue = field.value;
        rawValue = rawValue.replace(/\D/g, ''); // Remove non-digits
        if (rawValue.length > 10) {
            rawValue = rawValue.slice(0, 10); // Limit to 10 digits
        }
        field.value = rawValue;
        var fieldValue = field.value.trim();
        this.errors = []; // Clear previous errors
        var valid = true;
        var formGroup = $(field).closest('.form__group');
        formGroup.removeClass('form__group--error');
        // Reset previous field error tracking
        if (field.name && this.dlFieldsError.includes(field.name)) {
            this.dlFieldsError = this.dlFieldsError.filter(function (f) { return f !== field.name; });
        }
        // Rule 1: Empty
        if (fieldValue === '') {
            this.errors.push('Please enter a contact number');
            valid = false;
        }
        // Rule 2: Must be 10 digits and only numbers
        if (!/^\d{10}$/.test(fieldValue)) {
            this.errors.push('Contact number must be exactly 10 digits and contain only numbers');
            valid = false;
        }
        // Rule 3: Must start with 0
        if (!fieldValue.startsWith('0')) {
            this.errors.push('Contact number must start with a zero');
            valid = false;
        }
        // Rule 4: Invalid patterns, repeated digits, disallowed prefixes, or starts with 00
        var invalidContactNumbers = [
            '1234567890', '0000000000', '9999999999', '1111111111', '2222222222',
            '3333333333', '4444444444', '5555555555', '6666666666', '7777777777',
            '8888888888', '0123456789', '0987654321', '1231231231', '3213213213',
            '0820000000', '0831234567', '0811111111', '0840000000', '0710000000',
            '0600000000', '0650000000', '0111111111', '0210000000', '0800123456',
            '0800000000', '0801111111', '0860000000', '0861123456', '0860001234',
            '0800001234', '0800123', '0861234567', '0861234', '08123'
        ];
        var invalidPrefixes = [
            '080', '086', '087', '088', '089',
            '090', '091', '092', '093', '094', '095',
            '096', '097', '098', '099'
        ];
        var prefix = fieldValue.substring(0, 3);
        if (/^(\d)\1{9}$/.test(fieldValue) || // Same digit repeated 10 times
            invalidContactNumbers.includes(fieldValue) || // Blacklisted numbers
            invalidPrefixes.includes(prefix) || // Disallowed prefixes
            fieldValue.startsWith('00') // Starts with 00 (e.g. 002...)
        ) {
            this.errors.push('Please enter a valid South African contact number');
            valid = false;
        }
        // Final error rendering
        if (!valid) {
            formGroup.addClass('form__group--error');
            if (field.name && !this.dlFieldsError.includes(field.name)) {
                this.dlFieldsError.push(field.name);
            }
        }
        return valid;
    };
    //End
    ValidationService.prototype.validateContactInternationalNumber = function (field) {
        var valid = true;
        if (field.value.length < 5 || field.value.length > 15) {
            var form_group = field.closest('.form__group');
            form_group.classList.add('form__group--error');
            this.errors.push('Please enter a valid number');
            valid = false;
            // Analytics - ensure that the field name is not already in the log
            if (field.name && this.dlFieldsError.indexOf(field.name) < 0) {
                this.dlFieldsError.push(field.name);
            }
        }
        if (isNaN(field.value)) {
            var form_group = field.closest('.form__group');
            form_group.classList.add('form__group--error');
            this.errors.push('Please insert only numbers in this field');
            valid = false;
            // Analytics - ensure that the field name is not already in the log
            if (field.name && this.dlFieldsError.indexOf(field.name) < 0) {
                this.dlFieldsError.push(field.name);
            }
        }
        else if (!this.validateContactInternational(field)) {
            var form_group = field.closest('.form__group');
            form_group.classList.add('form__group--error');
            this.errors.push('This contact number is invalid');
            valid = false;
            // Analytics - ensure that the field name is not already in the log
            if (field.name && this.dlFieldsError.indexOf(field.name) < 0) {
                this.dlFieldsError.push(field.name);
            }
        }
        return valid;
    };
    ValidationService.prototype.validateAreaCode = function (field) {
        var valid = true;
        if (field.value.length != 4) {
            this.errors.push('A South African area code is 4 digits');
        }
        var areaCode = /^(?!0{4})[0-9]{4}$/g;
        if (!areaCode.test(field.value)) {
            var form_group = $(field).closest('.form__group');
            form_group.addClass('form__group--error');
            this.errors.push('This field can only contain numbers');
            valid = false;
            // Analytics - ensure that the field name is not already in the log
            if (field.name && this.dlFieldsError.indexOf(field.name) < 0) {
                this.dlFieldsError.push(field.name);
            }
        }
        return valid;
    };
    ValidationService.prototype.validateBusinessRegistrationNumber = function (field) {
        var _check = field.value.split('/');
        var _regValid = false;
        if (_check.length > 1) {
            var _valid1 = false;
            var _valid2 = false;
            var _valid3 = false;
            if (_check.length == 3) {
                var _seg1 = new RegExp('^[0-9]{4}$');
                var _seg2 = new RegExp('^[0-9]{6}$');
                var _seg3 = new RegExp('^[0-9]{2}$');
                if (_seg1.test(_check[0])) {
                    _valid1 = true;
                }
                if (_seg2.test(_check[1])) {
                    _valid2 = true;
                }
                if (_seg3.test(_check[2])) {
                    _valid3 = true;
                }
                if (_valid1 && _valid2 && _valid3) {
                    _regValid = true;
                }
            }
            else {
                _regValid = false;
            }
        }
        else if (field.value.length >= 12) {
            var _numberCheck = new RegExp('^[0-9]+$');
            if (!_numberCheck.test(field.value)) {
                _regValid = false;
            }
        }
        if ((!_regValid) && (field.value)) {
            var form_group = $(field).closest('.form__group');
            form_group.addClass('form__group--error');
            this.errors.push('The format of this business registration number is incorrect');
            // Analytics - ensure that the field name is not already in the log
            if (field.name && this.dlFieldsError.indexOf(field.name) < 0) {
                this.dlFieldsError.push(field.name);
            }
        }
        return _regValid;
    };
    // Main validateSAID function
    ValidationService.prototype.validateSAID = function (field) {
        var input = field;
        var value = input.value.trim();
        // Check length and numeric
        if (!/^\d{13}$/.test(value))
            return false;
        // Disallow all digits the same
        if (value.slice().every(function (char) { return char === value[0]; }))
            return false;
        // Pattern detection after first two digits
        if (value.length > 2) {
            var afterTwo = value.slice(2);
            var len = afterTwo.length;
            // Case 1: all identical after first two
            if (/^(\d)\1+$/.test(afterTwo))
                return false;
            // Case 2: sequential ascending or descending
            var isAsc = true, isDesc = true;
            for (var i = 1; i < len; i++) {
                var prev = parseInt(afterTwo.charAt(i - 1), 10);
                var curr = parseInt(afterTwo.charAt(i), 10);
                if (curr !== prev + 1)
                    isAsc = false;
                if (curr !== prev - 1)
                    isDesc = false;
                if (!isAsc && !isDesc)
                    break;
            }
            if (isAsc || isDesc)
                return false;
            // Case 3: repeating patterns length 2–4 (fixed)
            for (var patternLen = 2; patternLen <= 4; patternLen++) {
                var pattern = afterTwo.slice(0, patternLen);
                var repeated = pattern.repeat(Math.ceil(len / patternLen)).slice(0, len);
                if (repeated === afterTwo)
                    return false;
            }
        }
        // Full-value repetitive pattern detection
        for (var patternLen = 1; patternLen <= 6; patternLen++) {
            var pattern = value.substring(0, patternLen);
            var repeated = pattern.repeat(Math.ceil(13 / patternLen)).substring(0, 13);
            if (repeated === value)
                return false;
            for (var start = 1; start <= Math.min(6, 13 - patternLen * 2); start++) {
                pattern = value.substring(start, start + patternLen);
                var remainingLength = 13 - start;
                if (remainingLength >= patternLen * 2) {
                    repeated = pattern.repeat(Math.ceil(remainingLength / patternLen)).substring(0, remainingLength);
                    var testStr = value.substring(start);
                    if (repeated === testStr)
                        return false;
                }
            }
        }
        // Excessive repetition of any single digit (>6)
        for (var i = 0; i <= 13 - 7; i++) {
            var char = value.charAt(i);
            var consecutive = 1;
            for (var j = i + 1; j < 13 && value.charAt(j) === char; j++)
                consecutive++;
            if (consecutive >= 7)
                return false;
        }
        // Date validation
        var year = parseInt(value.substring(0, 2));
        var month = parseInt(value.substring(2, 4));
        var day = parseInt(value.substring(4, 6));
        var fullYear = year <= 49 ? 2000 + year : 1900 + year;
        if (month < 1 || month > 12 || day < 1 || day > 31)
            return false;
        var date = new Date(fullYear, month - 1, day);
        if (date.getFullYear() !== fullYear || date.getMonth() + 1 !== month || date.getDate() !== day)
            return false;
        // Gender sequence
        var genderSeq = parseInt(value.substring(6, 10), 10);
        if (genderSeq < 1 || genderSeq > 9999)
            return false;
        // Citizenship digit
        var citizenshipDigit = value.charAt(10);
        if (citizenshipDigit !== '0' && citizenshipDigit !== '1' && citizenshipDigit !== '2')
            return false;
        // Luhn check
        var checkSum = 0;
        for (var i = 0; i < 12; i++) {
            var digit = parseInt(value.charAt(i), 10);
            if (i % 2 === 0)
                checkSum += digit;
            else {
                var doubled = digit * 2;
                checkSum += doubled > 9 ? doubled - 9 : doubled;
            }
        }
        var expectedCheckDigit = (10 - (checkSum % 10)) % 10;
        var actualCheckDigit = parseInt(value.charAt(12), 10);
        if (expectedCheckDigit !== actualCheckDigit)
            return false;
        return true;
    };
    // Less strict validation (keeps error messages)
    ValidationService.prototype.validateSAIDLessStrict = function (field) {
        var valid = true;
        var value = field.value.trim();
        // Length
        if (value.length !== 13) {
            this.errors.push('South African ID is 13 digits');
            valid = false;
        }
        // SAID regex (validates date format including leap years)
        var SAIDRegEx = /^(((\d{2}((0[13578]|1[02])(0[1-9]|[12]\d|3[01])|(0[13456789]|1[012])(0[1-9]|[12]\d|30)|02(0[1-9]|1\d|2[0-8])))|([02468][048]|[13579][26])0229))(( |-)(\d{4})( |-)(\d{3})|(\d{7}))$/;
        // Citizenship & gender
        var citizenshipDigit = value.charAt(10);
        var genderSeq = parseInt(value.substring(6, 10), 10);
        // Luhn check
        var luhnValid = true;
        if (value.length === 13 && /^\d{13}$/.test(value)) {
            var checkSum = 0;
            for (var i = 0; i < 12; i++) {
                var digit = parseInt(value.charAt(i), 10);
                if (i % 2 === 0)
                    checkSum += digit;
                else {
                    var doubled = digit * 2;
                    checkSum += doubled > 9 ? doubled - 9 : doubled;
                }
            }
            var expectedCheckDigit = (10 - (checkSum % 10)) % 10;
            var actualCheckDigit = parseInt(value.charAt(12), 10);
            luhnValid = expectedCheckDigit === actualCheckDigit;
        }
        // Final validation — per SA ID spec: date regex, Luhn, citizenship (0/1/2), gender range
        if (!SAIDRegEx.test(value) || !luhnValid || genderSeq < 0 || genderSeq > 9999 || (citizenshipDigit !== '0' && citizenshipDigit !== '1' && citizenshipDigit !== '2')) {
            var form_group = $(field).closest('.form__group');
            if (!form_group.hasClass("form__group--hidden")) {
                form_group.addClass('form__group--error');
                this.errors.push('South African ID number is invalid');
                if (field.name && this.dlFieldsError.indexOf(field.name) < 0)
                    this.dlFieldsError.push(field.name);
            }
            valid = false;
        }
        return valid;
    };
    ValidationService.prototype.validatePassport = function (field) {
        var valid = true;
        var input = field;
        var passportRegex = new RegExp("^[a-zA-Z0-9]*$");
        if (!passportRegex.test(input.value)) {
            if (field.value) {
                var form_group = field.closest('.form__group');
                form_group.classList.add('form__group--error');
                this.errors.push('The format of this passport number is incorrect');
                valid = false;
                // Analytics - ensure that the field name is not already in the log
                if (field.name && this.dlFieldsError.indexOf(field.name) < 0) {
                    this.dlFieldsError.push(field.name);
                }
            }
        }
        return valid;
    };
    ValidationService.prototype.validateIsNumber = function (n) {
        return !isNaN(parseFloat(n)) && isFinite(n);
    };
    ValidationService.prototype.validateCurrency = function (field) {
        var valid = true;
        var validField = true;
        if (field.value.toString().length > 10) {
            validField = false;
        }
        else if (this.validateIsNumber(field.value)) {
            var rgx = /^\s*(?=.*[1-9])\d*(?:\.\d{1,2})?$/;
            validField = field.value.match(rgx);
        }
        else {
            validField = false;
        }
        if (!validField) {
            if (field.value) {
                var form_group = $(field).closest('.form__group');
                form_group.addClass('form__group--error');
                this.errors.push('The format of this currency field is incorrect');
                valid = false;
                // Analytics - ensure that the field name is not already in the log
                if (field.name && this.dlFieldsError.indexOf(field.name) < 0) {
                    this.dlFieldsError.push(field.name);
                }
            }
        }
        return valid;
    };
    ValidationService.prototype.validateCurrency2 = function (field) {
        var valid = true;
        var validField = true;
        if (field.value.toString().length > 18) {
            validField = false;
        }
        else if (this.validateIsNumber(field.value)) {
            var rgx = /^\s*(?=.*[1-9])\d*(?:\.\d{1,2})?$/;
            validField = field.value.match(rgx);
        }
        else {
            validField = false;
        }
        if (!validField) {
            if (field.value) {
                var form_group = $(field).closest('.form__group');
                form_group.addClass('form__group--error');
                this.errors.push('The format of this currency field is incorrect');
                valid = false;
                // Analytics - ensure that the field name is not already in the log
                if (field.name && this.dlFieldsError.indexOf(field.name) < 0) {
                    this.dlFieldsError.push(field.name);
                }
            }
        }
        return valid;
    };
    ValidationService.prototype.validateContact = function (field) {
        var international = false;
        var domain = window.location.href;
        if (domain.includes('https://preview.standardbank.co.za/southafrica') ||
            domain.includes('http://pwempas1v.standardbank.co.za:8080/southafrica') ||
            domain.includes('http://pwempas2v.standardbank.co.za:8080/southafrica') ||
            domain.includes('http://uwempas1v.standardbank.co.za:8080/southafrica') ||
            domain.includes('http://uwempas2v.standardbank.co.za:8080/southafrica') ||
            domain.includes('http://dsbgchop183.standardbank.co.za:8080/southafrica') ||
            domain.includes('https://www.standardbank.co.za') ||
            domain.includes('https://wem.standardbank.co.za/southafrica') ||
            domain.includes('https://uatprev.standardbank.co.za/southafrica') ||
            domain.includes('http://10.109.131.53:8080//southafrica')) {
            international = false;
        }
        else {
            international = true;
        }
        if (!international) {
            var is_zero_number_correct = true;
            var num = void 0;
            num = /^0[0-9]\d{8}$/g;
            if (num.test(field.value) === false) {
                is_zero_number_correct = false;
            }
            else {
                is_zero_number_correct = true;
            }
            return is_zero_number_correct;
        }
        else {
            return true;
        }
    };
    ValidationService.prototype.validateContactInternational = function (field) {
        var is_zero_number_correct = true;
        var num;
        num = /^[0-9]*$/g;
        if (num.test(field.value) === false) {
            is_zero_number_correct = false;
        }
        else {
            is_zero_number_correct = true;
        }
        return is_zero_number_correct;
    };
    ValidationService.prototype.validateEmail = function (field) {
        var input = field;
        var value = input.value.trim();
        var valid = true;
        // Max length: 241 characters
        if (input.length > 241) {
            $(field).closest('.form__group').addClass('form__group--error');
            this.errors.push('Email address must not exceed 241 characters.');
            if (field.name && this.dlFieldsError.indexOf(field.name) < 0) {
                this.dlFieldsError.push(field.name);
            }
            return false;
        }
        // Block @i.cloud.com and @<single-char>.cloud.com (e.g. @1.cloud.com, @x.cloud.com)
        var blockedCloudPattern = /@([a-zA-Z0-9])\.cloud\.com$/i;
        // Block numeric-only domains (like user@12345.com)
        var numericOnlyDomainPattern = /@(\d+)\.[a-zA-Z]{2,63}$/i;
        // Main email regex:
        // Username: letters, digits, and allowed special characters (_ . - +)
        // Cannot start or end with special character
        // Domain: letters, digits, hyphens, dots
        // TLD: letters only, 2-63 chars
        var EmailRegEx = /^(?![.])(?!.*[.]{2})([A-Za-z0-9._%+-]+)(?<![.])@([A-Za-z0-9](?:[A-Za-z0-9-]{0,61}[A-Za-z0-9])?\.)+[A-Za-z]{2,63}$/i;
        if (!EmailRegEx.test(value) || // invalid format
            blockedCloudPattern.test(value) || // blocked cloud pattern
            numericOnlyDomainPattern.test(value) // numeric-only domain
        ) {
            if (value !== '') {
                $(field).closest('.form__group').addClass('form__group--error');
                this.errors.push('The format of this email address is incorrect.');
                if (field.name && this.dlFieldsError.indexOf(field.name) < 0) {
                    this.dlFieldsError.push(field.name);
                }
                valid = false;
            }
        }
        return valid;
    };
    ValidationService.prototype.validateWebsiteAddress = function (field) {
        var valid = true;
        var input = field;
        var addressRegEx = /[`~!@#$%^&*()+=\[\]{};"\\|,<>?]/;
        if (addressRegEx.test(input.value)) {
            if (field.value) {
                var form_group = $(field).closest('.form__group');
                form_group.addClass('form__group--error');
                this.errors.push('The format of this webiste address is incorrect');
                valid = false;
                // Analytics - ensure that the field name is not already in the log
                if (field.name && this.dlFieldsError.indexOf(field.name) < 0) {
                    this.dlFieldsError.push(field.name);
                }
            }
        }
        return valid;
    };
    ValidationService.prototype.validateAccountNumber = function (field) {
        var valid = true;
        var accountNumbers = /^[0-9]*$/g;
        var format = /[`~.!@#$%^&*()_+=\[\]{};:"\\|,<>\/?]/;
        if (isNaN(field.value)) {
            var form_group = $(field).closest('.form__group');
            form_group.addClass('form__group--error');
            this.errors.push('Please insert only numbers in this field');
            valid = false;
            // Analytics - ensure that the field name is not already in the log
            if (field.name && this.dlFieldsError.indexOf(field.name) < 0) {
                this.dlFieldsError.push(field.name);
            }
        }
        else if (accountNumbers.test(field.value) == false || format.test(field.value) == true) {
            var form_group = $(field).closest('.form__group');
            form_group.addClass('form__group--error');
            this.errors.push('This field can only contain numbers');
            valid = false;
            // Analytics - ensure that the field name is not already in the log
            if (field.name && this.dlFieldsError.indexOf(field.name) < 0) {
                this.dlFieldsError.push(field.name);
            }
        }
        return valid;
    };
    ValidationService.prototype.validateAccount = function (field) {
        var account = /^[0-9]*$/;
        if (account.test(field.value)) {
            return true;
        }
        else {
            return false;
        }
    };
    ValidationService.prototype.getDataConsentValue = function (form, selector) {
        var radioBtn = form.querySelector("input[name=\"" + selector + "\"]:checked");
        if (radioBtn && radioBtn.checked) {
            return radioBtn.value;
        }
        else {
            return null;
        }
    };
    ValidationService.prototype.formatBusinessReg = function (event) {
        var _stringLength = parseFloat(event.length);
        var _newLength = (_stringLength - 1);
        var _check = event.substring(_newLength);
        var reg = new RegExp('^[0-9]+$');
        if (reg.test(_check)) {
            if (event.length == 4) {
                event = event += '/';
            }
            else if (event.length == 11) {
                event = event += "/";
            }
            else if (event.length > 14) {
                event = event.substring(0, 14);
            }
        }
        else {
            return event.substring(0, _newLength);
        }
        return event;
    };
    ValidationService.prototype.formatExpression = function (inputText) {
        var _check = inputText.split('/');
        if (_check.length > 1) {
            var _valid1 = true;
            var _valid2 = true;
            var _valid3 = true;
            if (_check.length == 3) {
                var _seg1 = new RegExp('^/d{4}$');
                var _seg2 = new RegExp('^/d{6}$');
                var _seg3 = new RegExp('^/d{2}$');
                if (_seg1.test(_check[0])) {
                    _valid1 = false;
                }
                if (_seg2.test(_check[1])) {
                    _valid2 = false;
                }
                if (_seg3.test(_check[2])) {
                    _valid3 = false;
                }
                if (_valid1 && _valid2 && _valid3) {
                    return inputText;
                }
                else {
                    return '';
                }
            }
            else {
                return '';
            }
        }
        else if (inputText.length >= 12) {
            var _firstcharacters = inputText.substring(0, 4);
            var _secondCharacters = inputText.substring(5, 10);
            var _thirdCharacters = inputText.substring(11, 13);
            return _firstcharacters + '/' + _secondCharacters + '/' + _thirdCharacters;
        }
        return '';
    };
    //
    //
    // CALCULATOR
    //
    //
    ValidationService.prototype.validateCalculator = function (event, button) {
        // varaibles
        event.preventDefault();
        var field = event.target;
        var formValid = true;
        var value = field.value;
        var fieldValue = value.replace(/ /g, '');
        var fieldAddon = field;
        var required = field.getAttribute('data-validation-required');
        var title = field.getAttribute('data-validation-title');
        var minimum = parseFloat(field.getAttribute('min'));
        var maximum = parseFloat(field.getAttribute('max'));
        var greaterThan = field.getAttribute('data-validation-greater-than');
        var lessThan = field.getAttribute('data-validation-less-than');
        // removeErrors
        $(field).closest('.calculator-form__group').removeClass('calculator-form__error');
        $(field).closest('.calculator-form__group').find('div.calculator-form__error-label').remove();
        // required
        if (required == "true") {
            if (fieldValue.length == 0 || fieldValue == '' || fieldValue == 0) {
                formValid = false;
                if (minimum) {
                    if (maximum) {
                        if (title) {
                            this.validateCalculatorError(event, 'Enter an amount between ' + this.formatNumbers(minimum) + ' and ' + this.formatNumbers(maximum) + ' ' + title);
                        }
                        else {
                            this.validateCalculatorError(event, 'Enter an amount between ' + this.formatNumbers(minimum) + ' and ' + this.formatNumbers(maximum));
                        }
                    }
                    else {
                        this.validateCalculatorError(event, 'Enter the minimum value of ' + this.formatNumbers(minimum));
                    }
                }
                else {
                    this.validateCalculatorError(event, 'Enter an amount');
                }
            }
        }
        // min
        if (minimum > parseFloat(fieldValue)) {
            formValid = false;
            if (title && maximum) {
                this.validateCalculatorError(event, 'Enter an amount between ' + this.formatNumbers(minimum) + ' and ' + this.formatNumbers(maximum) + ' ' + title);
            }
            else if (!title && maximum) {
                this.validateCalculatorError(event, 'Enter an amount between ' + this.formatNumbers(minimum) + ' and ' + this.formatNumbers(maximum));
            }
            else if (!title && !maximum) {
                this.validateCalculatorError(event, 'Enter the minimum value of ' + this.formatNumbers(minimum));
            }
        }
        // max
        if (maximum > 0) {
            if (maximum < parseFloat(fieldValue)) {
                formValid = false;
                if (title) {
                    this.validateCalculatorError(event, 'Enter an amount between ' + this.formatNumbers(minimum) + ' and ' + this.formatNumbers(maximum) + ' ' + title);
                }
                else {
                    this.validateCalculatorError(event, 'Enter an amount between ' + this.formatNumbers(minimum) + ' and ' + this.formatNumbers(maximum));
                }
            }
        }
        else {
            if (maximum < parseFloat(fieldValue)) {
                formValid = false;
                if (title) {
                    this.validateCalculatorError(event, 'The maximum you can insert is 0 ' + title);
                }
                else {
                    this.validateCalculatorError(event, 'The maximum you can insert is 0');
                }
            }
        }
        // greater than
        if (greaterThan) {
            var fieldsGreaterThan = $(field).closest('form').find('input[name=' + greaterThan + ']');
            if (parseFloat(fieldValue) <= $(fieldsGreaterThan).val()) {
                formValid = false;
                this.validateCalculatorError(event, 'Enter an amount greater than the expenses field');
            }
        }
        // less than
        if (lessThan) {
            var fieldsLessThan = $(field).closest('form').find('input[name=' + lessThan + ']');
            if (fieldsLessThan.length > 1) {
                var amount_1 = 0;
                $(fieldsLessThan).each(function (index) {
                    var valueElement = $(this).val();
                    if (!valueElement) {
                        amount_1 = amount_1 + 0;
                    }
                    else {
                        amount_1 = amount_1 + parseFloat(valueElement);
                    }
                });
                if (parseFloat(fieldValue) >= amount_1) {
                    formValid = false;
                    this.validateCalculatorError(event, 'Enter an amount (expenses may not exceed total income)');
                }
            }
            else {
                if (parseFloat(fieldValue) >= $(fieldsLessThan).val()) {
                    formValid = false;
                    this.validateCalculatorError(event, 'Enter an amount (expenses may not exceed total income)');
                }
            }
        }
        return formValid;
    };
    ValidationService.prototype.validateCalculatorError = function (event, message) {
        if (message === void 0) { message = ''; }
        event.preventDefault();
        var field = event.target;
        var closestGroup = field.closest('.calculator-form__group');
        $(closestGroup).find('.calculator-form__error-label').remove();
        $(closestGroup).addClass('calculator-form__error').append('<div class="calculator-form__error-label">' + message + '</div>');
    };
    //WPBBSA CALCULATOR VALIDATOR FOR ALL FIELDS FOR ANALYTICS
    ValidationService.prototype.validateWpbbsaCalculatorAllFields = function (allFields, button) {
        var _this = this;
        var analyticsService = new AnalyticsService();
        var dlCalculatorFieldsError = [];
        var formValid = true;
        allFields.forEach(function (element) {
            // varaibles
            var field = element;
            var fieldGroup = field.closest('.wpbbsa-calculator-form__group');
            var fieldValue = field.value;
            var fieldAddon = field;
            var required = field.getAttribute('data-validation-required');
            var title = field.getAttribute('data-validation-title');
            var minimum = parseFloat(field.getAttribute('min'));
            var maximum = parseFloat(field.getAttribute('max'));
            var greaterThan = field.getAttribute('data-validation-greater-than');
            var lessThan = field.getAttribute('data-validation-less-than');
            // removeErrors
            $(field).closest('.wpbbsa-calculator-form__group').removeClass('wpbbsa-calculator-form__error');
            $(field).closest('.wpbbsa-calculator-form__group').find('div.wpbbsa-calculator-form__error-label').remove();
            if (fieldGroup && !fieldGroup.classList.contains('wpbbsa-calculator-form__hidden')) {
                // required
                if (required == "true") {
                    if (field.type == "text" || field.type == "select" || field.type == "select-one") {
                        if (fieldValue.length == 0 || fieldValue == "" || fieldValue == null) {
                            formValid = false;
                            _this.validateWpbbsaCalculatorErrorAllFields(field, 'This field is required', dlCalculatorFieldsError);
                        }
                    }
                    else {
                        if (fieldValue.length == 0) {
                            formValid = false;
                            if (minimum) {
                                if (maximum) {
                                    if (title) {
                                        _this.validateWpbbsaCalculatorErrorAllFields(field, 'Enter an amount between ' + _this.formatNumbers(minimum) + ' and ' + _this.formatNumbers(maximum) + ' ' + title, dlCalculatorFieldsError);
                                    }
                                    else {
                                        _this.validateWpbbsaCalculatorErrorAllFields(field, 'Enter an amount between ' + _this.formatNumbers(minimum) + ' and ' + _this.formatNumbers(maximum), dlCalculatorFieldsError);
                                    }
                                }
                                else {
                                    _this.validateWpbbsaCalculatorErrorAllFields(field, 'Enter an amount', dlCalculatorFieldsError);
                                }
                            }
                            else {
                                _this.validateWpbbsaCalculatorErrorAllFields(field, 'Enter an amount', dlCalculatorFieldsError);
                            }
                        }
                    }
                }
                //check date
                if (field.type == "text" && field.classList.contains('form__datepicker')) {
                    if (fieldValue != "" && fieldValue != null) {
                        var date = new Date(fieldValue);
                        if (date.toString().toUpperCase() == "INVALID DATE" || isNaN(Date.parse(fieldValue))) {
                            _this.validateWpbbsaCalculatorErrorAllFields(field, 'Incorrect Date', dlCalculatorFieldsError);
                        }
                        else if (date > new Date()) {
                            _this.validateWpbbsaCalculatorErrorAllFields(field, 'Cannot use selected date', dlCalculatorFieldsError);
                        }
                    }
                }
                // min
                if (minimum > parseFloat(fieldValue)) {
                    formValid = false;
                    if (title && maximum) {
                        _this.validateWpbbsaCalculatorErrorAllFields(field, 'Enter an amount between ' + _this.formatNumbers(minimum) + ' and ' + _this.formatNumbers(maximum) + ' ' + title, dlCalculatorFieldsError);
                    }
                    else if (!title && maximum) {
                        _this.validateWpbbsaCalculatorErrorAllFields(field, 'Enter an amount between ' + _this.formatNumbers(minimum) + ' and ' + _this.formatNumbers(maximum), dlCalculatorFieldsError);
                    }
                    else if (!title && !maximum) {
                        _this.validateWpbbsaCalculatorErrorAllFields(field, 'Enter an amount', dlCalculatorFieldsError);
                    }
                }
                // max
                if (maximum > 0) {
                    if (maximum < parseFloat(fieldValue)) {
                        formValid = false;
                        if (title) {
                            _this.validateWpbbsaCalculatorErrorAllFields(field, 'Enter an amount between ' + _this.formatNumbers(minimum) + ' and ' + _this.formatNumbers(maximum) + ' ' + title, dlCalculatorFieldsError);
                        }
                        else {
                            _this.validateWpbbsaCalculatorErrorAllFields(field, 'Enter an amount between ' + _this.formatNumbers(minimum) + ' and ' + _this.formatNumbers(maximum), dlCalculatorFieldsError);
                        }
                    }
                }
                else {
                    if (maximum < parseFloat(fieldValue)) {
                        formValid = false;
                        if (title) {
                            _this.validateWpbbsaCalculatorErrorAllFields(field, 'The maximum you can insert is 0 ' + title, dlCalculatorFieldsError);
                        }
                        else {
                            _this.validateWpbbsaCalculatorErrorAllFields(field, 'The maximum you can insert is 0', dlCalculatorFieldsError);
                        }
                    }
                }
                // greater than
                if (greaterThan) {
                    var fieldsGreaterThan = $(field).closest('form').find('input[name=' + greaterThan + ']');
                    if (parseFloat(fieldValue) <= $(fieldsGreaterThan).val()) {
                        formValid = false;
                        _this.validateWpbbsaCalculatorErrorAllFields(field, 'Enter an amount greater than the expenses field', dlCalculatorFieldsError);
                    }
                }
                // less than
                if (lessThan) {
                    var fieldsLessThan = $(field).closest('form').find('input[name=' + lessThan + ']');
                    if (fieldsLessThan.length > 1) {
                        var amount_2 = 0;
                        $(fieldsLessThan).each(function (index) {
                            var valueElement = $(this).val();
                            if (!valueElement) {
                                amount_2 = amount_2 + 0;
                            }
                            else {
                                amount_2 = amount_2 + parseFloat(valueElement);
                            }
                        });
                        if (parseFloat(fieldValue) >= amount_2) {
                            formValid = false;
                            _this.validateWpbbsaCalculatorErrorAllFields(field, 'Enter an amount (expenses may not exceed total income)', dlCalculatorFieldsError);
                        }
                    }
                    else {
                        if (parseFloat(fieldValue) >= $(fieldsLessThan).val()) {
                            formValid = false;
                            _this.validateWpbbsaCalculatorErrorAllFields(field, 'Enter an amount (expenses may not exceed total income)', dlCalculatorFieldsError);
                        }
                    }
                }
            }
        });
        //If we have any errors on client side, trigger analytics to record all fields
        if (dlCalculatorFieldsError.length) {
            analyticsService.dtmFormFieldsValidationFail(dlCalculatorFieldsError.join(','));
        }
        return formValid;
    };
    ValidationService.prototype.validateWpbbsaCalculatorErrorAllFields = function (field, message, dlCalculatorFieldsError) {
        if (message === void 0) { message = ''; }
        var closestGroup = field.closest('.wpbbsa-calculator-form__group');
        $(closestGroup).addClass('wpbbsa-calculator-form__error').append('<div class="wpbbsa-calculator-form__error-label">' + message + '</div>');
        // Analytics - ensure that the field name is not already in the log
        if (field.name && dlCalculatorFieldsError.indexOf(field.name) < 0) {
            dlCalculatorFieldsError.push(field.name);
        }
    };
    ValidationService.prototype.validateWpbbsaCalculator = function (field, button) {
        // varaibles
        var fieldGroup = field.closest('.wpbbsa-calculator-form__group');
        var formValid = true;
        var fieldValue = field.value;
        var fieldAddon = field;
        var required = field.getAttribute('data-validation-required');
        var title = field.getAttribute('data-validation-title');
        var minimum = parseFloat(field.getAttribute('min'));
        var maximum = parseFloat(field.getAttribute('max'));
        var greaterThan = field.getAttribute('data-validation-greater-than');
        var lessThan = field.getAttribute('data-validation-less-than');
        // removeErrors
        $(field).closest('.wpbbsa-calculator-form__group').removeClass('wpbbsa-calculator-form__error');
        $(field).closest('.wpbbsa-calculator-form__group').find('div.wpbbsa-calculator-form__error-label').remove();
        if (fieldGroup && !fieldGroup.classList.contains('wpbbsa-calculator-form__hidden')) {
            // required
            if (required == "true") {
                if (field.type == "text" || field.type == "select" || field.type == "select-one") {
                    if (fieldValue.length == 0 || fieldValue == "" || fieldValue == null) {
                        formValid = false;
                        this.validateWpbbsaCalculatorError(field, 'This field is required');
                    }
                }
                else {
                    if (fieldValue.length == 0) {
                        formValid = false;
                        if (minimum) {
                            if (maximum) {
                                if (title) {
                                    this.validateWpbbsaCalculatorError(field, 'Enter an amount between ' + this.formatNumbers(minimum) + ' and ' + this.formatNumbers(maximum) + ' ' + title);
                                }
                                else {
                                    this.validateWpbbsaCalculatorError(field, 'Enter an amount between ' + this.formatNumbers(minimum) + ' and ' + this.formatNumbers(maximum));
                                }
                            }
                            else {
                                this.validateWpbbsaCalculatorError(field, 'Enter an amount');
                            }
                        }
                        else {
                            this.validateWpbbsaCalculatorError(field, 'Enter an amount');
                        }
                    }
                }
            }
            //check date
            if (field.type == "text" && field.classList.contains('form__datepicker')) {
                if (fieldValue != "" && fieldValue != null) {
                    var date = new Date(fieldValue);
                    if (date.toString().toUpperCase() == "INVALID DATE" || isNaN(Date.parse(fieldValue))) {
                        this.validateWpbbsaCalculatorError(field, 'Incorrect Date');
                    }
                    else if (date > new Date()) {
                        this.validateWpbbsaCalculatorError(field, 'Cannot use selected date');
                    }
                }
            }
            // min
            if (minimum > parseFloat(fieldValue)) {
                formValid = false;
                if (title && maximum) {
                    this.validateWpbbsaCalculatorError(field, 'Enter an amount between ' + this.formatNumbers(minimum) + ' and ' + this.formatNumbers(maximum) + ' ' + title);
                }
                else if (!title && maximum) {
                    this.validateWpbbsaCalculatorError(field, 'Enter an amount between ' + this.formatNumbers(minimum) + ' and ' + this.formatNumbers(maximum));
                }
                else if (!title && !maximum) {
                    this.validateWpbbsaCalculatorError(field, 'Enter an amount');
                }
            }
            // max
            if (maximum > 0) {
                if (maximum < parseFloat(fieldValue)) {
                    formValid = false;
                    if (title) {
                        this.validateWpbbsaCalculatorError(field, 'Enter an amount between ' + this.formatNumbers(minimum) + ' and ' + this.formatNumbers(maximum) + ' ' + title);
                    }
                    else {
                        this.validateWpbbsaCalculatorError(field, 'Enter an amount between ' + this.formatNumbers(minimum) + ' and ' + this.formatNumbers(maximum));
                    }
                }
            }
            else {
                if (maximum < parseFloat(fieldValue)) {
                    formValid = false;
                    if (title) {
                        this.validateWpbbsaCalculatorError(field, 'The maximum you can insert is 0 ' + title);
                    }
                    else {
                        this.validateWpbbsaCalculatorError(field, 'The maximum you can insert is 0');
                    }
                }
            }
            // greater than
            if (greaterThan) {
                var fieldsGreaterThan = $(field).closest('form').find('input[name=' + greaterThan + ']');
                if (parseFloat(fieldValue) <= $(fieldsGreaterThan).val()) {
                    formValid = false;
                    this.validateWpbbsaCalculatorError(field, 'Enter an amount greater than the expenses field');
                }
            }
            // less than
            if (lessThan) {
                var fieldsLessThan = $(field).closest('form').find('input[name=' + lessThan + ']');
                if (fieldsLessThan.length > 1) {
                    var amount_3 = 0;
                    $(fieldsLessThan).each(function (index) {
                        var valueElement = $(this).val();
                        if (!valueElement) {
                            amount_3 = amount_3 + 0;
                        }
                        else {
                            amount_3 = amount_3 + parseFloat(valueElement);
                        }
                    });
                    if (parseFloat(fieldValue) >= amount_3) {
                        formValid = false;
                        this.validateWpbbsaCalculatorError(field, 'Enter an amount (expenses may not exceed total income)');
                    }
                }
                else {
                    if (parseFloat(fieldValue) >= $(fieldsLessThan).val()) {
                        formValid = false;
                        this.validateWpbbsaCalculatorError(field, 'Enter an amount (expenses may not exceed total income)');
                    }
                }
            }
        }
        return formValid;
    };
    ValidationService.prototype.validateWpbbsaCalculatorError = function (field, message) {
        if (message === void 0) { message = ''; }
        var closestGroup = field.closest('.wpbbsa-calculator-form__group');
        $(closestGroup).addClass('wpbbsa-calculator-form__error').append('<div class="wpbbsa-calculator-form__error-label">' + message + '</div>');
    };
    ValidationService.prototype.validateWpbbsaCalculatorEvent = function (event, button) {
        // varaibles
        event.preventDefault();
        var field = event.target;
        var fieldGroup = field.closest('.wpbbsa-calculator-form__group');
        var formValid = true;
        var fieldValue = field.value;
        var fieldAddon = field;
        var required = field.getAttribute('data-validation-required');
        var title = field.getAttribute('data-validation-title');
        var minimum = parseFloat(field.getAttribute('min'));
        var maximum = parseFloat(field.getAttribute('max'));
        var greaterThan = field.getAttribute('data-validation-greater-than');
        var lessThan = field.getAttribute('data-validation-less-than');
        // removeErrors
        $(field).closest('.wpbbsa-calculator-form__group').removeClass('wpbbsa-calculator-form__error');
        $(field).closest('.wpbbsa-calculator-form__group').find('div.wpbbsa-calculator-form__error-label').remove();
        if (fieldGroup && !fieldGroup.classList.contains('wpbbsa-calculator-form__hidden')) {
            // required
            if (required == "true") {
                if (field.type == "text" || field.type == "select" || field.type == "select-one") {
                    if (fieldValue.length == 0 || fieldValue == "" || fieldValue == null) {
                        formValid = false;
                        this.validateWpbbsaCalculatorEventError(event, 'This field is required');
                    }
                }
                else {
                    if (fieldValue.length == 0) {
                        formValid = false;
                        if (minimum) {
                            if (maximum) {
                                if (title) {
                                    this.validateWpbbsaCalculatorEventError(event, 'Enter an amount between ' + this.formatNumbers(minimum) + ' and ' + this.formatNumbers(maximum) + ' ' + title);
                                }
                                else {
                                    this.validateWpbbsaCalculatorEventError(event, 'Enter an amount between ' + this.formatNumbers(minimum) + ' and ' + this.formatNumbers(maximum));
                                }
                            }
                            else {
                                this.validateWpbbsaCalculatorEventError(event, 'Enter an amount');
                            }
                        }
                        else {
                            this.validateWpbbsaCalculatorEventError(event, 'Enter an amount');
                        }
                    }
                }
            }
            //check date
            if (field.type == "text" && field.classList.contains('form__datepicker')) {
                if (fieldValue != "" && fieldValue != null) {
                    var date = new Date(fieldValue);
                    if (date.toString().toUpperCase() == "INVALID DATE" || isNaN(Date.parse(fieldValue))) {
                        this.validateWpbbsaCalculatorError(field, 'Incorrect Date');
                    }
                    else if (date > new Date()) {
                        this.validateWpbbsaCalculatorError(field, 'Cannot use selected date');
                    }
                }
            }
            // min
            if (minimum > parseFloat(fieldValue)) {
                formValid = false;
                if (title && maximum) {
                    this.validateWpbbsaCalculatorEventError(event, 'Enter an amount between ' + this.formatNumbers(minimum) + ' and ' + this.formatNumbers(maximum) + ' ' + title);
                }
                else if (!title && maximum) {
                    this.validateWpbbsaCalculatorEventError(event, 'Enter an amount between ' + this.formatNumbers(minimum) + ' and ' + this.formatNumbers(maximum));
                }
                else if (!title && !maximum) {
                    this.validateWpbbsaCalculatorEventError(event, 'Enter an amount');
                }
            }
            // max
            if (maximum > 0) {
                if (maximum < parseFloat(fieldValue)) {
                    formValid = false;
                    if (title) {
                        this.validateWpbbsaCalculatorEventError(event, 'Enter an amount between ' + this.formatNumbers(minimum) + ' and ' + this.formatNumbers(maximum) + ' ' + title);
                    }
                    else {
                        this.validateWpbbsaCalculatorEventError(event, 'Enter an amount between ' + this.formatNumbers(minimum) + ' and ' + this.formatNumbers(maximum));
                    }
                }
            }
            else {
                if (maximum < parseFloat(fieldValue)) {
                    formValid = false;
                    if (title) {
                        this.validateWpbbsaCalculatorEventError(event, 'The maximum you can insert is 0 ' + title);
                    }
                    else {
                        this.validateWpbbsaCalculatorEventError(event, 'The maximum you can insert is 0');
                    }
                }
            }
            // greater than
            if (greaterThan) {
                var fieldsGreaterThan = $(field).closest('form').find('input[name=' + greaterThan + ']');
                if (parseFloat(fieldValue) <= $(fieldsGreaterThan).val()) {
                    formValid = false;
                    this.validateWpbbsaCalculatorEventError(event, 'Enter an amount greater than the expenses field');
                }
            }
            // less than
            if (lessThan) {
                var fieldsLessThan = $(field).closest('form').find('input[name=' + lessThan + ']');
                if (fieldsLessThan.length > 1) {
                    var amount_4 = 0;
                    $(fieldsLessThan).each(function (index) {
                        var valueElement = $(this).val();
                        if (!valueElement) {
                            amount_4 = amount_4 + 0;
                        }
                        else {
                            amount_4 = amount_4 + parseFloat(valueElement);
                        }
                    });
                    if (parseFloat(fieldValue) >= amount_4) {
                        formValid = false;
                        this.validateWpbbsaCalculatorEventError(event, 'Enter an amount (expenses may not exceed total income)');
                    }
                }
                else {
                    if (parseFloat(fieldValue) >= $(fieldsLessThan).val()) {
                        formValid = false;
                        this.validateWpbbsaCalculatorEventError(event, 'Enter an amount (expenses may not exceed total income)');
                    }
                }
            }
        }
        return formValid;
    };
    ValidationService.prototype.validateWpbbsaCalculatorEventError = function (event, message) {
        if (message === void 0) { message = ''; }
        event.preventDefault();
        var field = event.target;
        var closestGroup = field.closest('.wpbbsa-calculator-form__group');
        $(closestGroup).addClass('wpbbsa-calculator-form__error').append('<div class="wpbbsa-calculator-form__error-label">' + message + '</div>');
    };
    ValidationService.prototype.formatNumbers = function (nStr) {
        nStr += '';
        var x = nStr.split('.');
        var x1 = x[0];
        var x2 = x.length > 1 ? '.' + x[1] : '';
        var rgx = /(\d+)(\d{3})/;
        while (rgx.test(x1)) {
            x1 = x1.replace(rgx, '$1' + ' ' + '$2');
        }
        return x1 + x2;
    };
    ValidationService.prototype.validateMinMaxLength = function (field) {
        var elementMin, elementMax;
        if (field.getAttribute('minlength')) {
            elementMin = field.getAttribute('minlength');
        }
        if (field.getAttribute('maxlength')) {
            elementMax = field.getAttribute('maxlength');
        }
        if (elementMin) {
            if (field.value.length < elementMin) {
                return false;
            }
        }
        if (elementMax) {
            if (field.value.length > elementMax) {
                return false;
            }
        }
        return true;
    };
    //Custom Validation for reCaptcha
    ValidationService.prototype.validateReCaptcha = function (valid, reCaptchaFormField) {
        var formGroup = reCaptchaFormField.closest('.form__group');
        this.errors = [];
        if (formGroup) {
            reCaptchaFormField.closest('.form__group').classList.remove('form__group--error');
            var errorMessage = reCaptchaFormField.querySelector(".form__group--error_message");
            if (errorMessage) {
                errorMessage.remove();
            }
        }
        if (valid == false) {
            var form_group = reCaptchaFormField.closest('.form__group');
            form_group.classList.add('form__group--error');
            this.errors.push('This checkbox is required to continue');
            valid = false;
            // Analytics - ensure that the field name is not already in the log
            if (this.dlFieldsError.indexOf("g-recaptcha") < 0) {
                this.dlFieldsError.push("g-recaptcha");
            }
        }
        this.addErrorMessage(reCaptchaFormField, this.errors);
    };
    return ValidationService;
}());
export { ValidationService };



//////////////////
// WEBPACK FOOTER
// ./services/validation.service.ts
// module id = 62
// module chunks = 0